import { Controller } from "@hotwired/stimulus"
// import Stripe from "stripe"
import { loadStripe } from '@stripe/stripe-js'

export default class extends Controller {
  static values = {
    publishableKey: String,
    clientSecret: String
  }
  
  connect() {
    this.initializeCheckout()
  }

  async initializeCheckout() {
    this.stripe = await loadStripe(this.publishableKeyValue)
    const checkout = await this.stripe.initEmbeddedCheckout({
      clientSecret: this.clientSecretValue
    });
  
    // Mount Checkout
    checkout.mount(this.element);
  }
} 